import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 2v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 22v-2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m17 20.66-1-1.73", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M11 10.27 7 3.34", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m20.66 17-1.73-1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m3.34 7 1.73 1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 12h8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M2 12h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m20.66 7-1.73 1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m3.34 17 1.73-1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m17 3.34-1 1.73", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m11 13.73-4 6.93", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Cog";
const Cog = memo(themed(Icon));
export {
  Cog
};
//# sourceMappingURL=cog.js.map
